// return
export function whenMapMetricsToPropsIsFunction(data) {
  return typeof data === 'function' ? data : undefined; //eslint-disable-line no-undefined
}

// just return the d
export function whenMapMetricsToPropsIsAnObject(data) {
  if (typeof data === 'object') {
    return () => data;
  }
  return undefined; // eslint-disable-line
}

export default [whenMapMetricsToPropsIsFunction, whenMapMetricsToPropsIsAnObject];
